import { axiosInstance } from './req';

export const joinGroupByCode = async (code: string) =>
    axiosInstance.get(`/api/v2/subscriptions/group/joinByCode/${code}`).then(({ data }) => data);
